export type ReadonlyCategoryEndpoints = {
    readonly SaveCategory: string;
    readonly GetCategory: string;
    readonly GetCategoryById: string;
    readonly UpdateCategory: string;
    readonly DeleteCategory: string;
    readonly GetCategoryDataReArrange: string; 
    readonly CheckActiveCategory:string;
  };
  
  const controller = 'api/Category'
  
  const CategoryEndpoints: ReadonlyCategoryEndpoints = {
    SaveCategory: `${controller}/AddUpdateCategory`,
    GetCategory: `${controller}/GetCategorys`,
    GetCategoryById: `${controller}/GetCategoryById`,
    UpdateCategory: `${controller}/AddUpdateCategory`,
    //DeleteCategory: `api/Category`,
    DeleteCategory: `${controller}/DeleteCategory`,
    GetCategoryDataReArrange: `${controller}/GetCategoryDataReArrange`,
    CheckActiveCategory:`${controller}/CheckActiveCategory`,
  };
  

 
    export { CategoryEndpoints };
  
  